import * as aj from "../aj/index";
import {SET_ACTIVE_MENU_ITEM, SETUP_MENU, CLEAR_ACTIVE_MENU_ITEM, SETUP_CUSTOM_MENU, UPDATE_MENU_ROOT} from "./types";
import menu from "../model/menu";
import { optional } from "../utils/lang";

export const setupMenu = aj.createAction(SETUP_MENU, data => {
    aj.dispatch({
        type: SETUP_MENU,
        user: data.user,
        menu: menu,
    })
})

export const resetMenu = setupMenu; //ToDo create proper action if we decide to perform additional operations here

export const setupCustomMenu = aj.createAction(SETUP_CUSTOM_MENU, data => {
    aj.dispatch({
        type: SETUP_CUSTOM_MENU,
        user: data.user,
        menu: optional(data.menu, []),
    })
})

export const updateMenuRoot = aj.createAction(UPDATE_MENU_ROOT, data => {
    aj.dispatch({
        type: UPDATE_MENU_ROOT,
        user: data.user, // Why do we keep passing this if it's not used?
        root: data.root,
    })
})

export const setActiveMenuItem = aj.createAction(SET_ACTIVE_MENU_ITEM, data => {
    aj.dispatch({
        type: SET_ACTIVE_MENU_ITEM,
        id: data.id,
    })
})

export const clearActiveMenuItem = aj.createAction(CLEAR_ACTIVE_MENU_ITEM, () => {
    aj.dispatch({
        type: CLEAR_ACTIVE_MENU_ITEM,
    })
})